import { Country } from '../types';

/**
 * Статичный справочник стран
 */
export const MOCK_COUNTRIES: Country[] = [
  {
    id: '1',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Кыргызская Республика'
  },
  {
    id: '2',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Российская Федерация'
  },
  {
    id: '3',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Республика Казахстан'
  },
  {
    id: '4',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Республика Узбекистан'
  },
  {
    id: '5',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Республика Таджикистан'
  },
  {
    id: '6',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Туркменистан'
  },
  {
    id: '7',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Республика Беларусь'
  },
  {
    id: '8',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Китайская Народная Республика'
  },
  {
    id: '9',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Турецкая Республика'
  },
  {
    id: '10',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Соединенные Штаты Америки'
  },
  {
    id: '11',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Федеративная Республика Германия'
  },
  {
    id: '12',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Французская Республика'
  },
  {
    id: '13',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Объединенное Королевство'
  },
  {
    id: '14',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Япония'
  },
  {
    id: '15',
    created_at: new Date().toISOString(),
    is_deleted: false,
    name: 'Республика Корея'
  }
];
